import React, { useCallback } from 'react';

import Table from 'components/common/Table';

import { productApi } from 'api';

import {
  PRODUCT_LIST_COLUMNS,
  PRODUCT_FILTER_OPTIONS,
} from 'constants/product';

const ManageProducts = () => {
  const exportApi = useCallback(params => {
    return productApi.exportProduct(params);
  }, []);

  return (
    <Table
      title="Manage Products"
      apiService={productApi}
      exportApi={exportApi}
      sortable={true}
      columns={PRODUCT_LIST_COLUMNS}
      filterOptions={PRODUCT_FILTER_OPTIONS}
    />
  );
};

export default ManageProducts;
